import { clsx } from 'clsx';
import { useEffect } from 'react';
import { Tooltip } from '../../../../tooltip/Tooltip';
import { Integration } from '../../../../shared/interfaces/integration';
import { Icon } from '../../../../icon/Icon';
import { useQuery } from '../../../../request/hooks/useQuery';
import { PipelineAPI } from '../../../api/PipelineAPI';
import { IntegrationDisplayConfigFactory } from '../../../factories/integrationFactory';
import { EntityDisplayConfigPopper } from '../../../../shared/components/EntityDisplayConfig/EntityDisplayConfigPopper/EntityDisplayConfigPopper';
import styles from './EditPipelineWizardHeaderLeft.module.scss';
import { EditingBadge } from '../../../../shared/components/EditingBadge/EditingBadge';

export function EditPipelineWizardHeaderLeft({ pipeline }: { pipeline?: Integration }) {
  const { data: integrationDisplayConfig, fetch: fetchIntegrationDisplayConfig } = useQuery({
    dataSource$: () =>
      PipelineAPI.getIntegrationDisplayConfig(pipeline!.id).then(res =>
        IntegrationDisplayConfigFactory(res.data)
      )
  });

  useEffect(() => {
    fetchIntegrationDisplayConfig();
  }, []);

  const { name } = pipeline!;

  return (
    <div className={clsx('flex-col', styles.leftWrapper)}>
      <div className='center-flex-row'>
        <Tooltip enableOnTextOverflow title={name} dataId='name'>
          <span className={clsx('text-subheading-2 text-ellipsis', styles.pipelineName)}>
            {name}
          </span>
        </Tooltip>

        <EditingBadge className='ml-2' />
      </div>

      <div className='center-flex-row mt-1'>
        <EntityDisplayConfigPopper
          logo={pipeline!.source!.sourceType.logo}
          logoDarkMode={pipeline!.source!.sourceType.logoDarkMode}
          title={pipeline!.source!.name}
          entityDisplayConfig={integrationDisplayConfig?.sourceDisplayConfig}
        />

        <Icon dataId='arrow' name='add-arrow-right' className='text-secondary text-body-1 mx-3' />

        <EntityDisplayConfigPopper
          logo={pipeline!.destination!.destinationType.logo}
          logoDarkMode={pipeline!.destination!.destinationType.logoDarkMode}
          title={pipeline!.destination!.name}
          entityDisplayConfig={integrationDisplayConfig?.destinationDisplayConfig}
        />
      </div>
    </div>
  );
}
